module.exports = __webpack_public_path__ + "static/media/home-eclipse.6da4cb9f.png";